export class Version {
  major: number;
  minor: number;
  revision: number;
  build: string | undefined;

  public static readonly FolderSeparator = "/";
  public static readonly FolderVersionPrefix = "v";
  public static readonly FolderVersionSeparator = ".";
  public static readonly FolderBuildSeparator = "-";

  public static readonly FileSeparator = "-";
  public static readonly FileVersionSeparator = "_";
  public static readonly FileBuildSeparator = "-";
  public static readonly FileVersionEnding = ".";

  //To handle: assets/bundles/v0.355.0/
  // (\/v(?<major>\d{1,4})\.(?<minor>\d{1,4})\.(?<revision>\d{1,4})(-(?<build>\w.*[^//]))?(\/?|$))+
  private static FolderRegExStr = `(\\${Version.FolderSeparator}${Version.FolderVersionPrefix}(?<major>\\d{1,4})\\${Version.FolderVersionSeparator}(?<minor>\\d{1,4})\\${Version.FolderVersionSeparator}(?<revision>\\d{1,4})(${Version.FolderBuildSeparator}(?<build>\\w.*[^//]))?(\\${Version.FolderSeparator}?|$))+`;
  private static FolderRegEx = new RegExp(Version.FolderRegExStr);

  // To handle: bundle-widget-local-0_356_0.js
  // -((?<major>\d{1,4})\_(?<minor>\d{1,4})\_(?<revision>\d{1,4})(_(?<build>\w.[^.]*))?(.|$))
  private static FileRegExStr = `(${Version.FileSeparator}(?<major>\\d{1,4})\\${Version.FileVersionSeparator}(?<minor>\\d{1,4})\\${Version.FileVersionSeparator}(?<revision>\\d{1,4})(${Version.FileBuildSeparator}(?<build>\\w.[^${Version.FileVersionEnding}]*))?(.|$))+`;
  private static FileRegEx = new RegExp(Version.FileRegExStr);

  // To handle: 0.0.0-build
  private static ParseRegExStr = `^(?<major>\\d{1,4}).(?<minor>\\d{1,4}).(?<revision>\\d{1,4})(-(?<build>\\w.*))?$`;
  private static ParseRegEx = new RegExp(Version.ParseRegExStr);

  constructor(major: number, minor: number, revision: number, build?: string) {
    this.major = major;
    this.minor = minor;
    this.revision = revision;
    this.build = build;
  }

  public toString(): string {
    return `${this.major}.${this.minor}.${this.revision}${this.build !== undefined ? "-" + this.build : ""}`;
  }

  // We get version bundles in the format: assets/bundles/v0.355.0/
  public static extractFolderVersion(text: string): Version | undefined {
    //console.log("Folder RegEx", this.FolderRegExStr, this.FolderRegEx);
    const result = this.FolderRegEx.exec(text);
    if (!result || !result.groups) return undefined;

    return new Version(Number(result.groups.major), Number(result.groups.minor), Number(result.groups.revision), result.groups.build);
  }

  // We get version bundles in the format: bundle-widget-local-0_356_0
  public static extractFileVersion(text: string): Version | undefined {
    //console.log("File RegEx", this.FileRegExStr, this.FileRegEx);
    const result = this.FileRegEx.exec(text);
    if (!result || !result.groups) return undefined;

    return new Version(Number(result.groups.major), Number(result.groups.minor), Number(result.groups.revision), result.groups.build);
  }

  // Parses the version exported by toString
  public static parse(text: string): Version {
    //console.log("Parse RegEx", this.ParseRegExStr, this.ParseRegEx);
    const result = this.ParseRegEx.exec(text);
    if (!result || !result.groups) throw Error(`Unable to parse version: ${text}`);

    return new Version(Number(result.groups.major), Number(result.groups.minor), Number(result.groups.revision), result.groups.build);
  }

  public static highestComparator(a: Version, b: Version): number {
    let result = b.major - a.major; // b - a => descending; a - b => ascending
    if (result === 0) {
      result = b.minor - a.minor;
      if (result === 0) {
        result = b.revision - a.revision;
        if (result === 0) {
          // The one WITHOUT the build should be higher
          if (b.build && a.build) result = b.build?.localeCompare(a.build, undefined, { sensitivity: "base" });
          else if (a.build)
            result = 1; // it means b is less => so higher!
          else if (b.build) result = -1;
        }
      }
    }
    return result;
  }
}
